import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { setCookie } from "../../utils";
import { useNavigate } from "react-router-dom";

import packageJson from '../../../package.json';

import imgLogin from '../../assets/imgs/img-login.png';
import { GET_DATA } from "../../services/API";

export default function Login() {
    const [loading, setLoading] = useState(false);
    const [serverError, setServerError] = useState("");

    const navigate = useNavigate();

    // Esquema de validação com Yup
    const validationSchema = Yup.object({
        login: Yup.string()
            .required("Login é obrigatório"),
        password: Yup.string()
            .min(6, "A senha deve ter pelo menos 6 caracteres")
            .required("A senha é obrigatória"),
    });

    // Configuração do Formik
    const formik = useFormik({
        initialValues: {
            login: "",
            password: "",
        },
        validationSchema,
        onSubmit: async (values) => {
            setLoading(true);
            setServerError("");
            
            const login = await GET_DATA(`UsuarioSistema/GetLogin?login=${values.login}&password=${values.password}`, false);

            if(login === null){
                setLoading(false);
                setServerError('Usuário e senha inválidos');
                return;
            }

            const auth = {
                login: values.login
            }

            setCookie("authToken", JSON.stringify(auth), 1/6); // 1/6 de um dia = 4 horas

            return navigate('/');

            // try {
            //     const response = await fetch("https://api.exemplo.com/auth", {
            //         method: "POST",
            //         headers: { "Content-Type": "application/json" },
            //         body: JSON.stringify(values),
            //     });

            //     const data = await response.json();

            //     if (!response.ok) {
            //         throw new Error(data.message || "Erro ao fazer login");
            //     }

            //     alert("Login bem-sucedido!");
            //     console.log("Token:", data.token);
            // } catch (err) {
            //     setServerError(err.message);
            // } finally {
            //     setLoading(false);
            // }
        },
    });

    return (
        <div className="w-full flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors">
            <div className="flex-1 flex items-center justify-center bg-gray-100 dark:bg-gray-900 p-8">
                <div className="w-full justify-center max-w-md p-6 bg-white dark:bg-gray-800 shadow-lg rounded-lg left-[10%]">
                    <h2 className="text-2xl font-bold text-center text-gray-800 dark:text-white mb-10">Rocket 01 - Gestor de Agentes</h2>

                    {/* Exibir erro do servidor, se houver */}
                    {serverError && <p className="text-red-500 text-sm text-center">{serverError}</p>}

                    <form onSubmit={formik.handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-gray-700 dark:text-gray-300 mb-2">Login</label>
                            <input
                                type="text"
                                name="login"
                                className={`w-full p-2 border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white ${
                                    formik.touched.login && formik.errors.login ? "border-red-500" : "focus:ring-blue-400"
                                }`}
                                placeholder="Digite seu login"
                                value={formik.values.login}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.login && formik.errors.login && (
                                <p className="text-red-500 text-xs mt-1">{formik.errors.login}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-gray-700 dark:text-gray-300 mb-2">Senha</label>
                            <input
                                type="password"
                                name="password"
                                className={`w-full p-2 border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white ${
                                    formik.touched.password && formik.errors.password ? "border-red-500" : "focus:ring-blue-400"
                                }`}
                                placeholder="Digite sua senha"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                            {formik.touched.password && formik.errors.password && (
                                <p className="text-red-500 text-xs mt-1">{formik.errors.password}</p>
                            )}
                        </div>
                        <div className="w-[100%] flex flex-row justify-center">
                            <p className="text-[#a7a7a7]">Versão: {packageJson.version} | © 2025 </p>
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-blue-500 dark:bg-blue-700 text-white p-2 rounded hover:bg-blue-600 dark:hover:bg-blue-800 transition"
                            disabled={loading}
                        >
                            {loading ? "Carregando..." : "Entrar"}
                        </button>
                    </form>
                </div>
            </div>
            <div className="flex-1 bg-cover bg-center flex flex-row justify-center">
                <img className="right-10" src={imgLogin} style={{ width: '100%', maxWidth: 450 }} />
            </div>
        </div>
    );
}